export const RQ_GET_RESIGNED_EMPLOYEE_HISTORY_REPORT_API = {
  url: 'employee/resigned-employee-list/<%= year %>?employeeCode=<%= employeeCode %>',
  method: 'GET',
  auth: true,
};
